export default __webpack_public_path__ + "static/media/share-icon.72f4a946.svg";